<template>
  <el-tabs class="group_4" v-model="activeTab" type="border-card" style="margin-top:10px">
    <el-tab-pane name="login">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">微信登录</div>
      </template>
      <div class="login-content">
        <!-- 二维码区域 -->
        <div class="qr-section">
          <div class="qr-title">请使用微信扫一扫登录</div>
          <div class="qr-container">
            <wxlogin class="wx-login" :appid="appid" :scope="'snsapi_login'" :theme="'black'"
              :redirect_uri=encodeURIComponent(redirect_url)
              href='data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTgwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQoucWxvZ2luX21vZCB7bWFyZ2luLXRvcDo0NXB4fQ=='
              :state="`${Math.random()}`" :delay="5000" self_redirect="false">
            </wxlogin>
          </div>
        </div>

        <!-- 其他登录方式组件 -->
        <OtherLoginMethods />
      </div>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:88%;margin-left:35px;height:60px;margin-top:40px;">
            <template #prepend>+86</template>
            <template #append>
              <span style="cursor:pointer;" @click="sendSmsCode()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="registerForm.email" class="email_signup" placeholder="请输入验证码"
            style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            :show-password="true" style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
            <template #append>
              <span style="cursor:pointer;" @click="register()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { getScanCode, wechatCallback } from '@/api/login'
import { setToken, removeToken } from '@/store/local/auth'
import { sendSmsCode, register } from '@/api/user';
import wxlogin from 'vue-wxlogin';
import OtherLoginMethods from '../components/OtherLoginMethods.vue';
export default {
  components: {
    wxlogin,
    OtherLoginMethods,
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    if (code && state) {
      const dev = urlParams.get('dev')
      //开发时，确保在8080端口运行
      if (dev == 'true') {
        window.location.replace('http://localhost:8080/store/entry/loginQRCode?code=' + code + '&state=' + state)
        return
      }
      //注意这里的代码，不知道为什么replace到当前页后，实测created和mounted钩子会被执行，所以需要延迟1s执行来确保只发送一次请求
      setTimeout(() => {
        wechatCallback(code, state).then(
          async response => {
            const { data } = response
            if (data.code == 1) {
              setToken(response.data.data.token)
/*               const userInfo = await this.$store.dispatch('user/getInfo')
              localStorage.setItem('userInfo', JSON.stringify(userInfo.data)) */
              this.$router.push('/talent')
            } else if (data.code == 0) {
              setTimeout(() => {
                const baseUrl = location.origin + location.pathname
                window.location.href = baseUrl
              }, 1000)
            }
          })
      }, 1000)
    } else {
      getScanCode(this.redirect_url).then(response => {
        const { data } = response
        this.QRCodeUrl = data.data.url
      })
    }
  },
  mounted() {
    this.wxobtain()
  },
  data() {
    return {
      appid: '',
      redirect_url: 'https://business.yuugeai.com/store/entry/loginQRCode',
      QRCodeUrl: '',
      activeTab: 'login',
      registerForm: {
        phone: '',
        email: '',
        password: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      },
    }
  },
  methods: {
    wxobtain() {
      getScanCode(this.redirect_url).then(response => {
        const { data } = response
        this.QRCodeUrl = data.data.url
        //获取appid
        const regex = /appid=([^&]+)/;
        const match = this.QRCodeUrl.match(regex);
        //获取扫码后跳转的地址
        const url = new URL(this.QRCodeUrl);
        this.redirect_url = decodeURIComponent(url.searchParams.get('redirect_uri'));

        if (match) {
          this.appid = match[1];
          console.log('Appid found:', this.appid);



        } else {
          console.log('Appid not found');
        }
      })

    },
    OpenQRCodeHtml() {
      window.location.replace(this.QRCodeUrl)
    },
    sendSmsCode() {
      sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' }).then(response => {
        if (response.data.code == 1) this.$message.success('验证码已发送，请注意查收')
      })
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        register({ account: this.registerForm.phone, password: this.registerForm.password, sms_code: this.registerForm.email, terminal: 4 })
          .then(response => {
            console.log(response)
          })
      })
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-form-item__error {
  left: 40px;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  min-height: 405px;
  height: auto;
  border: none;
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: transparent;
  overflow: visible;
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
  position: relative;
}

::v-deep .el-tabs__nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(101, 101, 135, 0.40);
}

::v-deep .el-tabs__item:nth-child(1) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  position: relative;
}

::v-deep .el-tabs__item:nth-child(1)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: 0px !important;
  position: relative;
}

::v-deep .el-tabs__item:nth-child(2)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: 0px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 60px;
  font-size: large;
}

::v-deep .email_login .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .email_login .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 18px;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* 登录内容容器 */
.login-content {
  padding: 30px 35px;
  background: transparent;
  position: relative;
  z-index: 5;
}

/* 二维码区域 */
.qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}

.qr-title {
  font-size: 18px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
}

.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.wx-login {
  width: 160px !important;
  height: 160px !important;
}

</style>